import { normalize } from 'normalizr';

import {
  httpGetSearchHistory,
  type SearchSearchHistorySchema,
} from '@iconik-io/iconik-api/src/services/search';
import { entitySchemas } from '@iconik-io/shared-lib/src/redux/entities/schemas';
import { updateEntities } from '@iconik-io/shared-lib/src/redux/entities/slice';

import type { AppDispatch } from '../../../store/types';
import { setSearchHistoryIds } from './slice';

export function fetchSearchHistory() {
  return (dispatch: AppDispatch): void => {
    dispatch(httpGetSearchHistory()).then((response) => {
      const { entities, result } = normalize<SearchSearchHistorySchema>(
        response.body.objects,
        [entitySchemas.search_history],
      );
      dispatch(updateEntities(entities));
      dispatch(setSearchHistoryIds(result));
    });
  };
}
